import { Component, inject } from '@angular/core';
import { ClarityModule } from '@clr/angular';
import { ApplicationToast, ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast-host',
  imports: [ClarityModule],
  templateUrl: './toast-host.component.html',
  styleUrl: './toast-host.component.scss',
})
export class ToastHostComponent {
  protected readonly toastService = inject(ToastService);

  protected alertType(toast: ApplicationToast): 'success' | 'danger' | 'warning' | 'info' {
    return toast.type === 'error' ? 'danger' : toast.type;
  }

  protected iconShape(toast: ApplicationToast): string {
    switch (toast.type) {
      case 'success':
        return 'check';
      case 'error':
        return 'times-circle';
      case 'warning':
        return 'warning-standard';
      case 'info':
        return 'info-circle';
    }
  }

  protected close(event: MouseEvent, toast: ApplicationToast): void {
    event.stopPropagation();
    this.toastService.close(toast.id);
  }
}
